// extracted by mini-css-extract-plugin
export var errorIcon = "_q0-1";
export var nameLogo = "_q0-0";